import { useTheme } from "styled-components";
import type { TypeTheme } from "@sproutsocial/seeds-react-theme";

/**
 * The useInteractiveColor hook has context of theme mode (light or dark)
 * and can be used to lighten or darken a color dynamically
 *
 * note: colors are limited to our theme colors
 */
const useInteractiveColor = (themeColor: string): string => {
  // Throw error if used outside of a ThemeProvider (styled-components)
  if (!useTheme()) {
    throw new Error(
      "useInteractiveColor() must be used within a Styled Components ThemeProvider"
    );
  }

  // Get the current theme mode ie. 'light' or 'dark'
  const theme: TypeTheme = useTheme() as TypeTheme;
  const themeMode = theme.mode;

  // If the theme mode is dark, return a lightened version of the themeValue
  if (themeMode === "dark") {
    return `color-mix(in srgb, ${themeColor}, white 20%)`;
  } else {
    // If the theme mode is light, return a darkened version of the themeValue
    return `color-mix(in srgb, ${themeColor}, black 20%)`;
  }
};

export { useInteractiveColor };
